// extracted by mini-css-extract-plugin
export default {"main":"main_main__NbpJD","container":"main_container__ffFFv"};